var map = {
	"./Skin64x64Alex.png": 32476,
	"./Skin64x64ReferenceAlex.png": 84500,
	"./Skin64x64ReferenceSteve.png": 68426,
	"./Skin64x64Steve.png": 32010,
	"./SteveDiamondArmor.png": 70413,
	"./SteveDiamondArmor256.png": 28882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41328;